// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__Qh-Vw","signatureBlock":"Footer_signatureBlock__3zDGG","signature":"Footer_signature__EFb_D"};